import { useCallback, useEffect, useState } from "react";

export default function useGetTopBarHeight() {
  const [top, setTop] = useState<string | number | undefined>(0);
  const handleCalculateTop = useCallback(() => {
    const topBarDiv = document.getElementById("layout-top-bar");
    if (topBarDiv) {
      const styles = window.getComputedStyle(topBarDiv as HTMLElement);
      setTop(styles.getPropertyValue("height") ?? "74px");
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      handleCalculateTop();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleCalculateTop]);

  useEffect(() => {
    handleCalculateTop();
  }, [handleCalculateTop]);

  return top;
}
